"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQLTimestampToDate = exports.stringToArrayBuffer = exports.intervalToSamplesPerMin = exports.sheet_from_array_of_arrays = void 0;
const xlsx_1 = __importDefault(require("xlsx"));
/**
 *
 * @param data array of arrays to create the sheet
 * @returns WorkSheet
 */
function sheet_from_array_of_arrays(data, options) {
    let ws = {};
    if (options && options.lockSpreadsheet) {
        ws["!protect"] = {
            password: options.spreadsheetPassword
                ? options.spreadsheetPassword
                : "Biomeme1234!",
        };
    }
    let range = {
        s: {
            c: 10000000,
            r: 10000000,
        },
        e: {
            c: 0,
            r: 0,
        },
    };
    for (let R = 0; R != data.length; ++R) {
        for (let C = 0; C != data[R].length; ++C) {
            if (range.s.r > R)
                range.s.r = R;
            if (range.s.c > C)
                range.s.c = C;
            if (range.e.r < R)
                range.e.r = R;
            if (range.e.c < C)
                range.e.c = C;
            let cell = {
                v: null,
            };
            if (data[R][C] && typeof data[R][C] == "object") {
                (cell.v = data[R][C].v), (cell.z = data[R][C].z);
            }
            else {
                cell.v = data[R][C];
            }
            if (cell.v == null)
                continue;
            let cell_ref = xlsx_1.default.utils.encode_cell({
                c: C,
                r: R,
            });
            if (typeof cell.v === "number")
                cell.t = "n";
            else if (typeof cell.v === "boolean")
                cell.t = "b";
            else if (cell.v instanceof Date) {
                cell.t = "n";
                cell.z = xlsx_1.default.SSF._table[14];
                cell.v = xlsx_1.default.SSF.datenum(cell.v);
            }
            else
                cell.t = "s";
            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000)
        ws["!ref"] = xlsx_1.default.utils.encode_range(range);
    return ws;
}
exports.sheet_from_array_of_arrays = sheet_from_array_of_arrays;
function intervalToSamplesPerMin(interval) {
    switch (interval) {
        case 30 * 1000:
            return 2;
        case 20 * 1000:
            return 3;
        case 15 * 1000:
            return 4;
        default:
            return 2;
    }
}
exports.intervalToSamplesPerMin = intervalToSamplesPerMin;
/**
 * Utility to convert xlsx generated string to an ArrayBuffer
 * for usage with filesaver
 * @param s The xlsx string to convert
 */
function stringToArrayBuffer(s) {
    const buffer = new ArrayBuffer(s.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
    }
    return buffer;
}
exports.stringToArrayBuffer = stringToArrayBuffer;
/**
 * Utility to format a SQL returned timestamp into a date string
 * @param timestamp The string timestamp to format
 */
function SQLTimestampToDate(timestamp) {
    return timestamp.split("T")[0].split("-").join("/");
}
exports.SQLTimestampToDate = SQLTimestampToDate;
